module.exports = __webpack_public_path__ + "img/a7f25bb1621e36f489453a4898974f41.png";